<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/nege_9781118044704_oeb_tp_r1">Title Page</a></div>
<div class="cbmh"><a href="#/nege_9781118044704_oeb_cop_r1">Copyright Page</a></div>
<div class="cfmh"><a href="#/nege_9781118044704_oeb_ded_r1">Dedication</a></div>
<div class="cfmh"><a href="#/nege_9781118044704_oeb_ack_r1">Acknowledgments</a></div>
<div class="cfmh"><a href="#/nege_9781118044704_oeb_itr_r1">Introduction</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h1">Who Should Read This Book</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h2">Who Are Bob and Susan Negen and Why Should You Listen to Them?</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h3">The Bad News</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h4">The Good News</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h5">The New Millennium Merchant</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h6">The WhizBang! Marketing System : Four Steps to Higher Sales and Happier Customers</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_itr_r1#h7">How to Use This Book</a></div>
<div> <br/></div>
<div class="cct"><a href="#/nege_9781118044704_oeb_c01_r1">STEP 1 - How to Get New Customers without Going Broke</a></div>
<div> <br/></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_c01_r1#h1">Five Key Concepts for Getting New Customers</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_c01_r1#h2">Six Low-Tech Tactics to Get New Customers without Going Broke</a></div>
<div class="ch1"><a href="#/nege_9781118044704_oeb_c01_r1#h3">Six High-Tech Tactics to Get New Customers</a></div>
<div> <br/></div>
<div class="cct"><span href="#/nege_9781118044704_oeb_c02_r1" title="Link target outside of Sample">SPECIAL SECTION - The Traditional Media</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c02_r1#h1" title="Link target outside of Sample">Selling Your Business versus Selling a Product</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c02_r1#h2" title="Link target outside of Sample">Picking the Right Advertising Media</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c02_r1#h3" title="Link target outside of Sample">Other Types of Advertising Tools</span></div>
<div> <br/></div>
<div class="cct"><span href="#/nege_9781118044704_oeb_c03_r1" title="Link target outside of Sample">SPECIAL SECTION - Copywriting for Retailers</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c03_r1#h1" title="Link target outside of Sample">Killer Copy: How to Write Messages That Sell</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c03_r1#h2" title="Link target outside of Sample">Other Concepts to Consider</span></div>
<div> <br/></div>
<div class="cct"><span href="#/nege_9781118044704_oeb_c04_r1" title="Link target outside of Sample">STEP 2 - Turn a First-Time Buyer into a Regular Customer</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c04_r1#h1" title="Link target outside of Sample">Two Key Concepts for Turning a First-Time Buyer into a Regular Customer</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c04_r1#h2" title="Link target outside of Sample">Three Low-Tech Tactics for Turning a First-Time Buyer into a Regular Customer</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c04_r1#h3" title="Link target outside of Sample">Two High-Tech Tactics for Turning a First-Time Buyer into a Regular Customer</span></div>
<div> <br/></div>
<div class="cct"><span href="#/nege_9781118044704_oeb_c05_r1" title="Link target outside of Sample">STEP 3 - Get Your Customers to Shop More Often</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c05_r1#h1" title="Link target outside of Sample">Two Key Concepts to Get Your Customers to Shop More Often</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c05_r1#h2" title="Link target outside of Sample">Four Low-Tech Tactics to Get Your Customers to Shop More Often</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c05_r1#h3" title="Link target outside of Sample">Four High-Tech Tactics to Get Your Customers to Shop More Often</span></div>
<div> <br/></div>
<div class="cct"><span href="#/nege_9781118044704_oeb_c06_r1" title="Link target outside of Sample">STEP 4 - Keep Your Customers for Life</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c06_r1#h1" title="Link target outside of Sample">Six Key Concepts to Keep Customers for Life</span></div>
<div class="ch1"><span href="#/nege_9781118044704_oeb_c06_r1#h2" title="Link target outside of Sample">Three Terrific Tactics to Keep Customers for Life</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/nege_9781118044704_oeb_bm1_r1" title="Link target outside of Sample">CONCLUSION</span></div>
<div class="cbmh"><span href="#/nege_9781118044704_oeb_in1_r1" title="Link target outside of Sample">INDEX</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nege_9781118044704_oeb_toc_r1.vue?594ccaa8